import { Component } from '@angular/core';
import { NavigationEnd, Router, RouterLink } from '@angular/router';
import { ActiveUserService } from '../../services/activeuser.service';
import { AsyncPipe, NgClass } from '@angular/common';
import { Client, GetMessagesCountResponse } from '../../generated-api-proxy';
import { CmsTextPipe } from '../../pipes/cms-text.pipe';
import { Brand } from 'src/brands/brand';

@Component({
  selector: 'app-top-tabs',
  standalone: true,
  imports: [RouterLink, NgClass, CmsTextPipe, AsyncPipe],
  templateUrl: './top-tabs.component.html',
  styleUrl: './top-tabs.component.scss'
})
export class TopTabsComponent {
  isRiskProfile: boolean = true;
  isMessages: boolean = false;
  hasUser: boolean = false;
  messageCount: number = 0;
  /** Without messages Risk profile would be the only tab, so the whole tab bar is hidden. */
  readonly messagesEnabled = Brand.messagesEnabled;

  constructor(private router: Router, private activeUser: ActiveUserService, private client: Client) {
    this.isRiskProfile = true;
    this.isMessages = !this.isRiskProfile;

    this.router.events
      .subscribe(event => {

        if (event instanceof NavigationEnd) {
          this.isRiskProfile = true;
          if (event.url.startsWith("/messages")) {
            this.isRiskProfile = false;
          }
          this.isMessages = !this.isRiskProfile;
        }
      });

    this.init();

    activeUser.loggedInChanged.subscribe((loggedIn: boolean) => {
      this.init();
    });
  }

  init() {
    if (this.activeUser.LoggedIn() && this.messagesEnabled) {
      this.messageCount = 0;

      this.client.messagesCount().subscribe((messages: GetMessagesCountResponse) => {
        this.messageCount = messages.result.unread;
      });

      this.hasUser = true;
    }
  }
}
